import { Database, FileSignature, Megaphone, MessageCircle, Newspaper, Search } from 'lucide-react';

/** Só o que o produto realmente consome hoje. */
const integrations = [
  { icon: Newspaper, label: 'DJEN' },
  { icon: Database, label: 'DataJud' },
  { icon: Megaphone, label: 'Meta Ads' },
  { icon: Search, label: 'Google Ads' },
  { icon: MessageCircle, label: 'WhatsApp' },
  { icon: FileSignature, label: 'Autentique' },
];

export function IntegrationsStrip() {
  return (
    <section aria-labelledby="lp-integrations-title" className="bg-white pb-20 pt-6 sm:pb-24">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-6">
        <h2 id="lp-integrations-title" className="text-(--lp-body) text-center text-[14px]">
          Conectado às fontes que o seu escritório já usa
        </h2>
        <ul className="border-(--lp-line) bg-(--lp-line) mt-7 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border sm:grid-cols-3 lg:grid-cols-6">
          {integrations.map(({ icon: Icon, label }, index) => (
            <li
              key={label}
              className="text-(--lp-ink) relative flex h-24 items-center justify-center gap-2 bg-white text-[17px] font-semibold tracking-[-0.02em]"
            >
              <span className="text-(--lp-mute) absolute left-3 top-2.5 text-[11px] font-medium">
                {String(index + 1).padStart(2, '0')}
              </span>
              <Icon size={19} className="text-(--lp-body)" />
              {label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
